import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\@babel\\runtime-corejs2/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.find-index";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createOrder as _createOrder } from '@/api';
import { deleteItem as _deleteItem } from '@/api/shoppingcart';
import CartEdit from "./Cart/CartEdit";
import Buyer from "./Cart/Buyer";
import Protocol from '@/components/Protocol';
import PageTitle from '@/components/PageTitle';
export default {
  components: {
    Buyer: Buyer,
    CartEdit: CartEdit,
    Protocol: Protocol,
    PageTitle: PageTitle
  },
  computed: {
    sumPrice: function sumPrice() {
      return this.$store.state.cartItems.reduce(function (init, item) {
        return item.price + init;
      }, 0).toFixed(2) - 0;
    },
    cartItems: function cartItems() {
      return this.$store.state.cartItems;
    },
    cartLoading: function cartLoading() {
      return this.$store.state.cartLoading;
    },
    needRealName: function needRealName() {
      return this.cartList.some(function (i) {
        return i.need_realname === 1;
      });
    }
  },
  data: function data() {
    return {
      loading: false,
      checked: false,
      cartListLoading: false,
      cartList: []
    };
  },
  methods: {
    deleteItem: function deleteItem(item) {
      var _this = this;

      this.$set(item, 'loading', true);

      _deleteItem(item.id).then(function (res) {
        _this.$message.success('删除成功');

        _this.cartList.splice(_this.cartList.findIndex(function (i) {
          return i.id === item.id;
        }), 1);

        _this.$store.dispatch('getCartItems');
      }).finally(function () {
        _this.$set(item, 'loading', false);
      });
    },
    showProtocol: function showProtocol() {
      this.$refs.protocol.show();
    },
    handleSubmit: function handleSubmit() {
      if (!this.checked) {
        this.$message.error('请确认勾选已阅读并同意购买协议');
        return;
      }

      this.$refs.buyer.show();
    },
    createOrder: function () {
      var _createOrder2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(buyer) {
        var params, orderInfo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(buyer, this.cartItems);
                buyer.buyer_name = this.needRealName ? buyer.buyer_name : '';
                buyer.buyer_identify = this.needRealName ? buyer.buyer_identify : '';
                params = _objectSpread({
                  buyer_papers_type: 'ID_CARD'
                }, buyer, {
                  price: this.sumPrice,
                  remark: '',
                  tickets: this.cartItems.map(function (item) {
                    return {
                      shopping_cart_id: item.id,
                      batch_type_id: item.batch_type_id,
                      guest_identify: item.guest_identify,
                      guest_papers_type: item.guest_papers_type,
                      guest_name: item.guest_name,
                      guest_phone: item.guest_phone,
                      play_date_begin: item.play_date_begin,
                      price: item.price,
                      ticket_type_id: item.ticket_type_id
                    };
                  })
                });
                this.loading = true;
                _context.prev = 5;
                _context.next = 8;
                return _createOrder(params).then(function (res) {
                  return res.data.extraInfo;
                });

              case 8:
                orderInfo = _context.sent;
                // 提前置空购物车数量
                this.$store.commit('SET_CART_ITEMS', []);
                this.$store.dispatch('getCartItems');
                this.$router.push({
                  name: 'ticketPay',
                  params: {
                    id: orderInfo.id
                  }
                });
                this.loading = false;
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](5);
                this.loading = false;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 15]]);
      }));

      function createOrder(_x) {
        return _createOrder2.apply(this, arguments);
      }

      return createOrder;
    }(),
    onRefresh: function onRefresh() {
      this.$store.dispatch('getCartItems');
    }
  },
  watch: {
    cartItems: {
      handler: function handler(val) {
        this.cartList = val;
      },
      immediate: true
    },
    cartLoading: function cartLoading(val) {
      this.cartListLoading = val;
    }
  }
};